import { render, staticRenderFns } from "./CommentSkeleton.vue?vue&type=template&id=37fa2c5c&"
import script from "./CommentSkeleton.vue?vue&type=script&lang=js&"
export * from "./CommentSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37fa2c5c')) {
      api.createRecord('37fa2c5c', component.options)
    } else {
      api.reload('37fa2c5c', component.options)
    }
    module.hot.accept("./CommentSkeleton.vue?vue&type=template&id=37fa2c5c&", function () {
      api.rerender('37fa2c5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/meeting-agendas/modal-items/comments/CommentSkeleton.vue"
export default component.exports